// extracted by mini-css-extract-plugin
module.exports = {"container":"Animation_container__2yHB_","card":"Animation_card__1r8QT","centerText":"Animation_centerText__s8GvV","animate":"Animation_animate__1xIb6"};